export const textareaPt = {
  root: 'pv-textarea'
};